export const FORCE_LOCAL_STORAGE = Symbol('FORCE_LOCAL_STORAGE')
export const SUBSCRIPTION_EVENT_DELAY = Symbol('SUBSCRIPTION_EVENT_DELAY')
